import { render } from "./Data6.vue?vue&type=template&id=16a56119"
import script from "./Data6.vue?vue&type=script&lang=js"
export * from "./Data6.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__